<!--
  ~ Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
  ~ Spin in het Web B.V. Apeldoorn.
  ~ Deze software mag alleen gebruikt / bekeken / gewijzigd worden
  ~ volgens de voorwaarden die zijn vastgelegd in de overeenkomst
  ~ tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
  ~ overeenkomsten tussen Slimme Infrasoftware B.V en
  ~ Spin in het Web B.V.
  -->

<div class="regel-editor regel-functie">
  <div class="regel-header d-flex align-items-center justify-content-between mb-2">
    <div class="d-flex align-items-center">
      <span class="badge badge-warning mr-2">{{ regelTypeNamen[regel.context].label }}</span>
      @if (!isRegelGeldig) {
        <span class="fas fa-exclamation-triangle text-warning" title="Kies ten minste 1 functie"></span>
      }
    </div>
    <filterregel-acties
      [clausuleId]="clausuleId!"
      [isInRootGroep]="isInRootGroep"
      (uitDezeGroep)="uitDezeGroep.emit($event)"
      (wikkelInEn)="wikkelInEn.emit($event)"
      (wikkelInOf)="wikkelInOf.emit($event)"
      (verwijder)="verwijder.emit($event)"></filterregel-acties>
  </div>

  <div class="regel-body d-flex align-items-center flex-wrap">
    @if (functies?.length) {
      <ng-select class="flex-grow-1 min-w-200"
                 [appendTo]="dropdownContainer"
                 [id]="id('functies')"
                 [items]="functies"
                 bindLabel="naam"
                 bindValue="id"
                 [multiple]="true"
                 [closeOnSelect]="false"
                 [searchable]="true"
                 [clearSearchOnAdd]="true"
                 placeholder="Kies functie(s)"
                 [(ngModel)]="gekozenFunctieIds"
                 (change)="functiesGewijzigd()">
      </ng-select>
    }
  </div>
</div>
